import React, { useEffect, useState } from 'react';

// material-ui
import { Grid, useMediaQuery, useTheme } from '@mui/material';

// project imports
import ImageBanner from '../ImageBanner';
import RedirectCard from '../RedirectCard';
import RedirectCard2 from '../RedirectCard2';
import RedirectCard3 from '../RedirectCard3';
import { gridSpacing } from '../../../store/constant';

//-----------------------|| DEFAULT DASHBOARD ||-----------------------//

const Dashboard = () => {
    const [isLoading, setLoading] = useState(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Grid container spacing={gridSpacing}>
            {isMobile ? (
                // Mobile layout adjustments
                <>
                    <Grid item xs={12}>
                        <ImageBanner isLoading={isLoading} />
                    </Grid>
                    <Grid item xs={12}>
                        <RedirectCard />
                    </Grid>
                    <Grid item xs={12}>
                        <RedirectCard2 />
                    </Grid>
                    <Grid item xs={12}>
                        <RedirectCard3 />
                    </Grid>
                </>
            ) : (
                // Default desktop layout
                <>
                    <Grid item xs={12}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <ImageBanner isLoading={isLoading} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item lg={4} md={4} sm={6} xs={12}>
                                <RedirectCard />
                            </Grid>
                            <Grid item lg={4} md={4} sm={6} xs={12}>
                                <RedirectCard2 />
                            </Grid>
                            <Grid item lg={4} md={4} sm={6} xs={12}>
                                <RedirectCard3 />
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default Dashboard;
